import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,
          LoadingController, Loading, AlertController  } from 'ionic-angular';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatabaseProvider } from '../../providers/database/database';
import { UIProvider } from '../../providers/ui/ui';


import { SMPItem } from '../smp/smpitem';

/**
 * Generated class for the SmpAddPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-smp-add',
  templateUrl: 'smp-add.html',
})
export class SmpAddPage {

  smpForm: FormGroup;
  loading: Loading;

  constructor(public navCtrl: NavController, public navParams: NavParams,  
              public formBuilder: FormBuilder, public alertCtrl: AlertController,
              public loadingCtrl: LoadingController, public dbProvider: DatabaseProvider,
              public uiProvider: UIProvider) {

   this.smpForm = formBuilder.group({

      date: ['', Validators.compose([Validators.required])],

      generatorRH: ['',  Validators.compose([Validators.required])],
      meterReading: [''],

      drumstripperRH: ['', Validators.compose([Validators.required])],
      nutsieveRH: ['', Validators.compose([Validators.required])],
      digesterRH: ['', Validators.compose([Validators.required])],
      palmoilpressRH: ['', Validators.compose([Validators.required])],
      palmoilclarificatorRH: ['', Validators.compose([Validators.required])],
      storagepumpCleaned: ['', Validators.compose([Validators.required])],

      kerneloilpressRH: ['', Validators.compose([Validators.required])],
      kerneloilclarificatorRH: ['', Validators.compose([Validators.required])],
      kernelcrackerRH: ['', Validators.compose([Validators.required])],
      kernelsieveRH: ['', Validators.compose([Validators.required])],

      factoryCleaned: [''],
      notes: ['', Validators.compose([Validators.minLength(5), 
      Validators.required])]
    });              

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SmpAddPage');
  }

  saveSmp() {
    console.log('ionViewDidLoad SmpAddPage saveSmp(...)');
    if (!this.smpForm.valid){
      console.log(this.smpForm.value);
      console.log('SmpAddPage user entry invalid(...)');
    } else {
      let aSMPItem : SMPItem = {
        date : this.smpForm.value.date,

        generatorRH : this.smpForm.value.generatorRH,
        meterReading : this.smpForm.value.meterReading,

        drumstripperRH : this.smpForm.value.drumstripperRH,
        nutsieveRH : this.smpForm.value.nutsieveRH,
        digesterRH : this.smpForm.value.digesterRH,
        palmoilpressRH : this.smpForm.value.palmoilpressRH,
        palmoilclarificatorRH : this.smpForm.value.palmoilclarificatorRH,
        storagepumpCleaned : this.smpForm.value.storagepumpCleaned,

        kerneloilpressRH : this.smpForm.value.kerneloilpressRH,
        kerneloilclarificatorRH : this.smpForm.value.kerneloilclarificatorRH,
        kernelcrackerRH : this.smpForm.value.kernelcrackerRH,
        kernelsieveRH : this.smpForm.value.kernelsieveRH,

        factoryCleaned : this.smpForm.value.factoryCleaned,
        notes : this.smpForm.value.notes,

        id : this.dbProvider.getDBId()
      }

      console.log('saving... ' + aSMPItem);
      this.dbProvider.saveSMPItem(aSMPItem);
      this.uiProvider.presentToast( "Saved S&M of " +  + aSMPItem.date, 3000);
      this.navCtrl.pop();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/smp-add/smp-add.ts